import React from "react";
import { Link } from "react-router-dom";
import { usePageMeta } from "../hooks/usePageMeta";

const Section = ({ title, children }) => (
  <div className="mb-10">
    <h2 className="text-xl md:text-2xl font-black text-[#0a2a5e] mb-3">{title}</h2>
    <div className="text-slate-600 leading-relaxed space-y-3">{children}</div>
  </div>
);

export default function PrivacyPolicy() {
  usePageMeta("Privacy Policy", "How Baishalii Tanks & Pipes collects, uses and protects the information you share through this website.");
  return (
    <div className="pt-[88px] md:pt-[112px]" data-testid="privacy-policy-page">
      <section className="relative py-20 bg-gradient-to-r from-[#061a3d] via-[#0a2a5e] to-sky-700 text-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h1 className="text-4xl sm:text-5xl font-black">Privacy Policy</h1>
          <p className="text-sky-200 mt-4">Last updated: July 2026</p>
        </div>
      </section>
      <section className="py-14 md:py-16 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <Section title="1. Who We Are">
            <p>
              Baishalii Tanks &amp; Pipes ("BAISHALII", "we", "us") manufactures water tanks, pipes &amp; fittings,
              sinks, cisterns, taps and allied products. This policy explains how we collect, use and protect the
              information you share with us through this website.
            </p>
          </Section>
          <Section title="2. Information We Collect">
            <p>We collect information you voluntarily provide when you:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Submit an enquiry through our contact form (name, email, phone number, subject and message).</li>
              <li>Subscribe to our newsletter (email address).</li>
              <li>Contact us via phone, email or WhatsApp chat.</li>
            </ul>
            <p>We do not collect payment information through this website.</p>
          </Section>
          <Section title="3. How We Use Your Information">
            <ul className="list-disc pl-6 space-y-1">
              <li>To respond to your enquiries and provide product or dealership information.</li>
              <li>To send occasional product updates and industry news if you subscribed to our newsletter.</li>
              <li>To improve our website, products and customer service.</li>
            </ul>
            <p>We do not sell, rent or trade your personal information to third parties.</p>
          </Section>
          <Section title="4. WhatsApp Chat">
            <p>
              Our website includes a WhatsApp chat widget provided by Interakt. When you use it, your conversation is
              handled through WhatsApp and is subject to WhatsApp's own privacy policy.
            </p>
          </Section>
          <Section title="5. Data Retention & Security">
            <p>
              Enquiry and newsletter data is stored securely and retained only as long as needed to serve your request
              or maintain your subscription. We use reasonable technical measures to protect your data against
              unauthorised access.
            </p>
          </Section>
          <Section title="6. Your Rights">
            <p>
              You may request access to, correction of, or deletion of your personal data at any time by writing to us
              at <a href="mailto:contact@baishalii.in" className="text-sky-600 hover:underline">contact@baishalii.in</a>.
              You can unsubscribe from our newsletter by contacting us at the same address.
            </p>
          </Section>
          <Section title="7. Changes to This Policy">
            <p>
              We may update this policy from time to time. The latest version will always be available on this page
              with the updated date shown above.
            </p>
          </Section>
          <Section title="8. Contact Us">
            <p>
              Baishalii Tanks &amp; Pipes<br />
              39 Strand Road, Room No. 25, Kolkata 700001<br />
              Toll-free: 1800 202 3360 · Email:{" "}
              <a href="mailto:contact@baishalii.in" className="text-sky-600 hover:underline">contact@baishalii.in</a>
            </p>
          </Section>
          <Link to="/contact" data-testid="privacy-contact-link" className="text-sky-600 font-semibold hover:underline">
            Have a question? Contact us →
          </Link>
        </div>
      </section>
    </div>
  );
}
